import React, { Fragment, useCallback, useState } from 'react';
import BaseForm from '../../../../../components/form/BaseForm';
import Panel from '../../../../../components/outline/Panel';
import ImgUpload from '../../../../../components/ImgUpload';
import TextArea from '../../../../../components/input/TextArea';
import Input from '../../../../../components/input/Input';
import Button from '../../../../../components/Button';
import Drawer from '../../../../../components/Drawer/Drawer';
import Img from '../../../../../components/Img/Img';
import Select from '../../../../../components/input/Select';
import Anchor from '../../../../../components/link/Anchor';
import RadioGroup from '../../../../../components/input/RadioGroup';
import {
  MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO,
  MAXIMUM_NUMBER_OF_REMOTE_IMAGE,
  MINIMUM_NUMBER_OF_REMOTE_IMAGE,
  REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE,
  REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_SELECT_LIST,
  REMOTE_IMAGE_DETAIL_PAGE_TYPE,
  REMOTE_REFERRAL_IMAGE_TYPE,
  REMOTE_REFERRAL_IMAGE_TYPE_TEXT,
  REMOTE_REFERRAL_MYPAGE_APP_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_MYPAGE_PC_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_MYPAGE_TABLET_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_MYPAGE_MOBILE_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_DETAIL_APP_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_DETAIL_PC_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_DETAIL_TABLET_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_DETAIL_MOBILE_IMAGE_ZEPLIN_URL,
  REMOTE_REFERRAL_LINK_TYPE_SELECT_LIST,
  REMOTE_IMAGE_ACTIVE_STATUS_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/remoteImageConstants';
import { setDash, addAllItemToSelectList } from '../../../../../lib/common';
import remoteReferralMyPageApp from '../../../../../static/images/remote/referral/remote-referral-mypage-app.png';
import remoteReferralMyPagePc from '../../../../../static/images/remote/referral/remote-referral-mypage-pc.png';
import remoteReferralMyPageTablet from '../../../../../static/images/remote/referral/remote-referral-mypage-tablet.png';
import remoteReferralMyPageMobile from '../../../../../static/images/remote/referral/remote-referral-mypage-mobile.png';
import remoteReferralDetailApp from '../../../../../static/images/remote/referral/remote-referral-detail-app.png';
import remoteReferralDetailPc from '../../../../../static/images/remote/referral/remote-referral-detail-pc.png';
import remoteReferralDetailTablet from '../../../../../static/images/remote/referral/remote-referral-detail-tablet.png';
import remoteReferralDetailMobile from '../../../../../static/images/remote/referral/remote-referral-detail-mobile.png';
import { IMAGE_TYPE_GUIDE_TEXT } from '../../../../../constants/service/common/commonConstants';
import './RemoteImageReferralDetailInfo.scss';

const RemoteImageReferralDetailInfo = (props) => {
  const { detailPageType, remoteImageReferralDetail, setData, copyUrl } = props;
  const {
    exposeLocationTypeEditable,
    exposeLocationType,
    appImg,
    pcImg,
    tabletImg,
    mobileImg,
    memo,
    linkType,
    linkId,
    appImgUrl,
    pcImgUrl,
    tabletImgUrl,
    mobileImgUrl,
    status,
  } = remoteImageReferralDetail;

  /**
   *  미리보기
   */
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [previewImgInfo, setPreviewImgInfo] = useState({
    img: null,
    url: null,
  });
  const toggleDrawerVisible = useCallback(() => setDrawerVisible(!drawerVisible), [drawerVisible]);

  return (
    <Panel className="remote-image-detail-info">
      <div className="panel-header">
        <div className="title">레퍼럴 이미지 정보</div>
      </div>

      <div className="panel-body">
        <BaseForm
          label="노출위치 타입"
          content={
            <Select
              className="expose-location-type"
              list={REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_SELECT_LIST}
              onChange={(type) => {
                setData({
                  path: ['remoteImageReferralDetail', 'exposeLocationType'],
                  value: type,
                });

                setData({
                  path: ['remoteImageReferralDetail', 'linkType'],
                  value: null,
                });
              }}
              defaultActiveFirstOption={false}
              value={exposeLocationType}
              isTable={true}
              isEditable={exposeLocationTypeEditable}
              size="large"
            />
          }
        />

        <BaseForm
          label="레퍼럴 상태"
          content={
            <RadioGroup
              value={status}
              list={REMOTE_IMAGE_ACTIVE_STATUS_TYPE_SELECT_LIST}
              onChange={(value) =>
                setData({
                  path: ['remoteImageReferralDetail', 'status'],
                  value,
                })
              }
              size="large"
            />
          }
        />

        <BaseForm
          label="링크 종류"
          content={
            <Select
              className="link-type"
              list={
                exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE
                  ? addAllItemToSelectList(REMOTE_REFERRAL_LINK_TYPE_SELECT_LIST, '없음')
                  : [{ id: null, name: '없음' }]
              }
              onChange={(type) =>
                setData({
                  path: ['remoteImageReferralDetail', 'linkType'],
                  value: type,
                })
              }
              value={linkType}
              isTable={true}
              size="large"
            />
          }
        />

        <BaseForm label="링크 ID" content={setDash(linkId)} />

        <BaseForm
          label="App 이미지"
          content={
            <div className="image-upload-area">
              <ImgUpload
                list={appImg}
                modalTitle="App 이미지"
                maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE}
                minCnt={MINIMUM_NUMBER_OF_REMOTE_IMAGE}
                setData={setData}
                targetPath={['remoteImageReferralDetail', 'appImg']}
              />

              <Button
                isRadius
                color="primary"
                text="미리보기"
                onClick={() => {
                  if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE) {
                    setPreviewImgInfo({
                      img: remoteReferralMyPageApp,
                      url: REMOTE_REFERRAL_MYPAGE_APP_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  } else if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL) {
                    setPreviewImgInfo({
                      img: remoteReferralDetailApp,
                      url: REMOTE_REFERRAL_DETAIL_APP_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  }
                }}
              />
            </div>
          }
          subContent={
            <div className="sub-info">
              <div>*사진은 테스트 어드민/앱에서 확인 후 적용해주세요.</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
            </div>
          }
        />

        {detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT && (
          <BaseForm
            label={`${REMOTE_REFERRAL_IMAGE_TYPE_TEXT[REMOTE_REFERRAL_IMAGE_TYPE.APP]} URL`}
            content={
              <Fragment>
                <Input className="img-url-input" value={appImgUrl} disabled={true} />

                <Button className="img-url-copy" text="복사하기" onClick={() => copyUrl(appImgUrl)} />
              </Fragment>
            }
          />
        )}

        <BaseForm
          label="PC 이미지"
          content={
            <div className="image-upload-area">
              <ImgUpload
                list={pcImg}
                modalTitle="PC 이미지"
                maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE}
                minCnt={MINIMUM_NUMBER_OF_REMOTE_IMAGE}
                setData={setData}
                targetPath={['remoteImageReferralDetail', 'pcImg']}
              />

              <Button
                isRadius
                color="primary"
                text="미리보기"
                onClick={() => {
                  if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE) {
                    setPreviewImgInfo({
                      img: remoteReferralMyPagePc,
                      url: REMOTE_REFERRAL_MYPAGE_PC_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  } else if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL) {
                    setPreviewImgInfo({
                      img: remoteReferralDetailPc,
                      url: REMOTE_REFERRAL_DETAIL_PC_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  }
                }}
              />
            </div>
          }
          subContent={
            <div className="sub-info">
              <div>*사진은 테스트 어드민/앱에서 확인 후 적용해주세요.</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
            </div>
          }
        />

        {detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT && (
          <BaseForm
            label={`${REMOTE_REFERRAL_IMAGE_TYPE_TEXT[REMOTE_REFERRAL_IMAGE_TYPE.PC]} URL`}
            content={
              <Fragment>
                <Input className="img-url-input" value={pcImgUrl} disabled={true} />

                <Button className="img-url-copy" text="복사하기" onClick={() => copyUrl(pcImgUrl)} />
              </Fragment>
            }
          />
        )}

        <BaseForm
          label="Tablet 이미지"
          content={
            <div className="image-upload-area">
              <ImgUpload
                list={tabletImg}
                modalTitle="Tablet 이미지"
                maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE}
                minCnt={MINIMUM_NUMBER_OF_REMOTE_IMAGE}
                setData={setData}
                targetPath={['remoteImageReferralDetail', 'tabletImg']}
              />

              <Button
                isRadius
                color="primary"
                text="미리보기"
                onClick={() => {
                  if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE) {
                    setPreviewImgInfo({
                      img: remoteReferralMyPageTablet,
                      url: REMOTE_REFERRAL_MYPAGE_TABLET_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  } else if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL) {
                    setPreviewImgInfo({
                      img: remoteReferralDetailTablet,
                      url: REMOTE_REFERRAL_DETAIL_TABLET_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  }
                }}
              />
            </div>
          }
          subContent={
            <div className="sub-info">
              <div>*사진은 테스트 어드민/앱에서 확인 후 적용해주세요.</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
            </div>
          }
        />

        {detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT && (
          <BaseForm
            label={`${REMOTE_REFERRAL_IMAGE_TYPE_TEXT[REMOTE_REFERRAL_IMAGE_TYPE.TABLET]} URL`}
            content={
              <Fragment>
                <Input className="img-url-input" value={tabletImgUrl} disabled={true} />

                <Button className="img-url-copy" text="복사하기" onClick={() => copyUrl(tabletImgUrl)} />
              </Fragment>
            }
          />
        )}

        <BaseForm
          label="Mobile 이미지"
          content={
            <div className="image-upload-area">
              <ImgUpload
                list={mobileImg}
                modalTitle="Mobile 이미지"
                maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE}
                minCnt={MINIMUM_NUMBER_OF_REMOTE_IMAGE}
                setData={setData}
                targetPath={['remoteImageReferralDetail', 'mobileImg']}
              />

              <Button
                isRadius
                color="primary"
                text="미리보기"
                onClick={() => {
                  if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE) {
                    setPreviewImgInfo({
                      img: remoteReferralMyPageMobile,
                      url: REMOTE_REFERRAL_MYPAGE_MOBILE_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  } else if (exposeLocationType === REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL) {
                    setPreviewImgInfo({
                      img: remoteReferralDetailMobile,
                      url: REMOTE_REFERRAL_DETAIL_MOBILE_IMAGE_ZEPLIN_URL,
                    });
                    toggleDrawerVisible();
                  }
                }}
              />
            </div>
          }
          subContent={
            <div className="sub-info">
              <div>*사진은 테스트 어드민/앱에서 확인 후 적용해주세요.</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
            </div>
          }
        />

        {detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT && (
          <BaseForm
            label={`${REMOTE_REFERRAL_IMAGE_TYPE_TEXT[REMOTE_REFERRAL_IMAGE_TYPE.MOBILE]} URL`}
            content={
              <Fragment>
                <Input className="img-url-input" value={mobileImgUrl} disabled={true} />

                <Button className="img-url-copy" text="복사하기" onClick={() => copyUrl(mobileImgUrl)} />
              </Fragment>
            }
          />
        )}

        <BaseForm
          label={
            <div className="remote-image-detail-memo-label">
              <div>메모</div>
              <div>
                (<span className="word-length">{memo && memo.length ? memo.length : 0}</span>/
                {MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO})
              </div>
            </div>
          }
          content={
            <TextArea
              value={memo}
              maxLength={MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO}
              onChange={(value) =>
                setData({
                  path: ['remoteImageReferralDetail', 'memo'],
                  value,
                })
              }
            />
          }
        />
      </div>

      <Drawer
        className="remote-image-info-drawer"
        title="레퍼럴 이미지"
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
      >
        <Img height={800} src={previewImgInfo.img} />

        <Anchor
          className="zeplin-link"
          color="primary"
          isUnderLine
          text={previewImgInfo.url}
          href={previewImgInfo.url}
          target="_blank"
        />
      </Drawer>
    </Panel>
  );
};

export default RemoteImageReferralDetailInfo;
